module.exports = __webpack_public_path__ + "7617c63ec7ff107bf34e6cbfc8060a93.png";